import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import TriColumnContainer from '@/components/tricolumncontainer';
import TriColumn from '@/components/tricolumn';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Language Support`}</h2>
    <p>{`GIPHY supports the following languages and offers unique regional content for many of the areas where these languages are spoken. You can leverage these benefits by passing the `}<inlineCode parentName="p">{`lang`}</inlineCode>{` param in your API request.`}</p>
    <TriColumnContainer title="Supported Languages" mdxType="TriColumnContainer">
  <TriColumn mdxType="TriColumn">
    <ul>
      <li> English (en)</li>
      <li> Spanish (es)</li>
      <li> Portuguese (pt)</li>
      <li> Indonesian (id)</li>
      <li> French (fr)</li>
      <li> Arabic (ar)</li>
      <li> Turkish (tr)</li>
      <li> Thai (th)</li>
      <li> Vietnamese (vi)</li>
      <li> German (de)</li>
      <li> Italian (it)</li>
    </ul>
  </TriColumn>
  <TriColumn mdxType="TriColumn">
    <ul>
      <li> Japanese (ja)</li>
      <li> Chinese Simplified (zh-CN)</li>
      <li> Chinese Traditional (zh-TW)</li>
      <li> Russian (ru)</li>
      <li> Korean (ko)</li>
      <li> Polish (pl)</li>
      <li> Dutch (nl)</li>
      <li> Romanian (ro)</li>
      <li> Hungarian (hu)</li>
      <li> Swedish (sv)</li>
      <li> Czech (cs)</li>
    </ul>
  </TriColumn>
  <TriColumn mdxType="TriColumn">
    <ul>
      <li> Hindi (hi)</li>
      <li> Bengali (bn)</li>
      <li> Danish (da)</li>
      <li> Farsi (fa)</li>
      <li> Filipino (tl)</li>
      <li> Finnish (fi)</li>
      <li> Hebrew (he)</li>
      <li> Malay (ms)</li>
      <li> Norwegian (no)</li>
      <li> Ukrainian (uk)</li>
    </ul>
  </TriColumn>
    </TriColumnContainer>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      